import appGlobalScript from '/home/gabriel/EloGroup/SydleUI/SacPopup/node_modules/@sydle/ui-design-system/dist/collection/global/setup.js';
export const globalScripts = appGlobalScript;
